import {
  deleteApiAuthorsId,
  getApiAuthorsId,
  postApiAuthors,
  putApiAuthorsId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const authorByIdQuery = createQuery({
  handler: getApiAuthorsId,
})

export const authorCreate = createMutation({
  handler: postApiAuthors,
})

export const authorUpdate = createMutation({
  handler: putApiAuthorsId,
})

export const authorDelete = createMutation({
  handler: deleteApiAuthorsId,
})
